export type Complex = { re: number; im: number };

export function cx(re: number, im = 0): Complex {
  return { re, im };
}

export function add(a: Complex, b: Complex): Complex {
  return { re: a.re + b.re, im: a.im + b.im };
}

export function mul(a: Complex, b: Complex): Complex {
  return { re: a.re * b.re - a.im * b.im, im: a.re * b.im + a.im * b.re };
}

export function mag2(z: Complex): number {
  return z.re * z.re + z.im * z.im;
}

export function mag(z: Complex): number {
  return Math.hypot(z.re, z.im);
}

export function eq(a: Complex, b: Complex, eps = 1e-12): boolean {
  return Math.abs(a.re - b.re) <= eps && Math.abs(a.im - b.im) <= eps;
}

/** Unicode minus so the printed number matches the plate captions. */
export function formatC(c: Complex, digits = 4): string {
  const re = c.re.toFixed(digits);
  const imAbs = Math.abs(c.im).toFixed(digits);
  const sign = c.im < 0 ? "−" : "+";
  return `${re} ${sign} ${imAbs}i`;
}

export function lerpC(a: Complex, b: Complex, t: number): Complex {
  return { re: a.re + (b.re - a.re) * t, im: a.im + (b.im - a.im) * t };
}
